import {Pinia} from 'pinia'
import {RouteLocationNormalized} from 'vue-router'
import {useWorkspaceStore} from '@toolify/client/src/stores/WorkspaceStore/useWorkspaceStore'
import {RouteName} from '@toolify/client/src/setup/router/enum/RouteName'

export function ensureBillingEnabledRouterHookFactory(pinia: Pinia) {
  return function ensureBillingEnabledRouterHook(to: RouteLocationNormalized) {
    if (!to.meta?.requireBilling) {
      return
    }

    const workspaceStore = useWorkspaceStore(pinia)
    if (workspaceStore.currentWorkspace?.isBillingEnabled) {
      return
    }

    const workspaceName = to.params.workspaceName as string | undefined
    if (workspaceName) {
      return {
        name: RouteName.WorkspaceSettings,
        params: {
          workspaceName,
        },
      }
    }

    return {
      name: RouteName.ChooseWorkspace,
    }
  }
}
